import React, { useState } from 'react';
import assetUrl from '../../utils/assetUrl';


const technologySlides = [
  {
    title: "EVE",
    description: "Eve is a fully reusable, two-stage orbital launch vehicle designed for sustained, high-cadence flight operations. As the first spacecraft to operationalize magnetohydrodynamic reentry (MHDR), Eve executes controlled atmospheric return by actively shaping the reentry plasma flow field, reducing direct convective and radiative heat flux to vehicle surfaces and thereby limiting dependence on conventional thermal protection systems. This enables full-vehicle recovery and up to 400 reflights per stage with minimal refurbishment, reducing the cost of access to space.",
    features: ["Learn More"],
    image: assetUrl('EVE WHT.png'),
    imagePosition: 'center',
    extendedDescription: "Eve represents a groundbreaking advancement in launch vehicle architecture, establishing itself as the world's first orbital rocket to incorporate Magnetohydrodynamic reentry (MHDR) technology as a baseline flight hardware. This revolutionary approach to second stage reentry pushes Eve beyond the traditional first-stage reusability seen in contemporary rockets, as Eve features a fully reusable second stage—a technical achievement that addresses one of the most significant cost drivers in spaceflight by recovering and refurbishing hardware that is typically expended after each mission. Both the first and second stages will perform Return to Site (RTS) operations, autonomously navigating back to the launch facility for rapid refurbishment and reintegration into the flight manifest. Designed with an ambitious operational lifetime target of 400 reflights per vehicle, Eve's architecture fundamentally challenges the economics of space access by dramatically reducing the marginal cost per launch through extensive hardware reuse. With a payload capacity of 1.5 metric tons to Low Earth Orbit (LEO) and 700 kilograms to Geostationary Orbit (GSO), Eve occupies a strategically important market segment that bridges the gap between small satellite launchers and heavy-lift vehicles, making it ideally suited for a diverse mission portfolio including small satellite constellation deployment, International Space Station resupply missions, technology demonstration flights, Earth observation payloads, and responsive launch operations for government and commercial customers seeking flexible, cost-effective access to space."
  }
];

const TechnologySection = ({ showModel, allowModelLoad, modelAvailable, isMobile = false, onToggleModel, onRemoveModel, onSelectStage }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isFading, setIsFading] = useState(false);

  
  
  
  
  
  
  
  
  

  
  
  
  

  
  
  
  
  
  
  
  
  

  const goToSlide = (index) => {
    if (index === currentSlide) return;
    setIsFading(false);
    setCurrentSlide(index);
  };


  return (
    <section id="technology-section" style={{ padding: '0 20px 60px', color: '#fff' }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto' }}>

          {}
          <div style={{ position: 'relative', overflow: 'hidden', borderRadius: '16px' }}>
            
            {}
            <div style={{
              display: 'flex'
            }}>
              {technologySlides.map((slide, index) => (
                <div key={index} style={{
                  flex: '0 0 100%',
                  position: 'relative',
                  backgroundColor: 'transparent',
                  border: '1px solid transparent',
                  borderRadius: '16px',
                  overflow: 'hidden',
                  outline: 'none',
                  minHeight: '520px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between'
                }}>
                  
                  {}
                  {!slide.image && (
                    <div style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundImage: `url(${assetUrl('logo.png')})`,
                      backgroundSize: '400px 400px',
                      backgroundPosition: 'right center',
                      backgroundRepeat: 'no-repeat',
                      opacity: '0.05',
                      filter: 'blur(1px)'
                    }} />
                  )}

                  {}
                  <div style={{
                    position: 'relative',
                    zIndex: 2,
                    display: 'flex',
                    justifyContent: 'flex-start',
                    padding: '3rem 2.5rem',
                    opacity: isFading ? 0 : 1,
                    transition: 'opacity 0.2s ease'
                  }}>
                    <div style={{ width: '100%', maxWidth: '760px', textAlign: 'left' }}>
                        <h3 style={{
                          fontSize: '1.5625rem',
                          fontWeight: '100',
                          color: 'white',
                          marginBottom: '0.3rem',
                          letterSpacing: '0.05em'
                        }}>
                          {slide.title}
                        </h3>
                        
                        <p style={{
                          fontSize: '1.1rem',
                          color: '#cbd5e1',
                          lineHeight: '1.7',
                          marginBottom: '0.4rem'
                        }}>
                          {slide.description}
                        </p>

                        {}
                        <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
                          {slide.features
                            .filter((feature) => feature !== 'Learn More')
                            .map((feature, featureIndex) => (
                              <div
                                key={featureIndex}
                                style={{
                                  padding: '0.5rem 1rem',
                                  backgroundColor: 'transparent',
                                  border: 'none',
                                  borderRadius: '20px',
                                  fontSize: '0.9rem',
                                  color: '#e2e8f0',
                                  fontWeight: '300'
                                }}
                              >
                                {feature}
                              </div>
                            ))}
                        </div>

                    </div>
                  </div>

                  <div style={{
                    padding: '0 2.5rem 2rem',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '0.75rem'
                  }}>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.75rem' }}>
                      {['Full-Stack', 'First Stage', 'Second Stage'].map((label, index) => (
                        <button
                          key={label}
                          onClick={() => {
                            goToSlide(index);
                            onSelectStage?.(index);
                          }}
                          className="retro-select-button"
                          data-selected={index === currentSlide}
                          style={{
                            padding: '0.5rem 1rem',
                            backgroundColor: 'transparent',
                            border: `1px solid ${index === currentSlide ? '#ffffff' : 'rgba(255, 255, 255, 0.5)'}`,
                            borderRadius: '20px',
                            fontSize: '0.9rem',
                            color: '#ffffff',
                            fontWeight: '300',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease, border-color 0.3s ease'
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'translateY(-3px)';
                            e.currentTarget.style.borderColor = '#ffffff';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.borderColor = index === currentSlide ? '#ffffff' : 'rgba(255, 255, 255, 0.5)';
                          }}
                        >
                          {label}
                        </button>
                      ))}

                      <button
                        type="button"
                        onClick={() => {
                          window.location.href = '/eve';
                        }}
                        className="tech-learn-more"
                        style={{
                          padding: '0.5rem 1rem',
                          backgroundColor: 'transparent',
                          border: '1px solid #5227FF',
                          borderRadius: '20px',
                          fontSize: '0.9rem',
                          color: '#e2e8f0',
                          fontWeight: '300',
                          cursor: 'pointer',
                          transition: 'all 0.3s ease, border-color 0.3s ease'
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = 'translateY(-3px)';
                          e.currentTarget.style.boxShadow = '0 0 20px rgba(82, 39, 255, 0.6), 0 6px 20px rgba(82, 39, 255, 0.3)';
                          e.currentTarget.style.borderColor = '#5227FF';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = 'translateY(0)';
                          e.currentTarget.style.boxShadow = 'none';
                          e.currentTarget.style.borderColor = '#5227FF';
                        }}
                      >
                        Learn More
                      </button>
                    </div>

                    {modelAvailable && !isMobile && (
                      <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem' }}>
                        <button
                          type="button"
                          onClick={onToggleModel}
                          style={{
                            padding: '0.5rem 1rem',
                            backgroundColor: 'transparent',
                            border: '1px solid #5227FF',
                            borderRadius: '20px',
                            fontSize: '0.9rem',
                            color: '#e2e8f0',
                            fontWeight: '300',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease, border-color 0.3s ease'
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'translateY(-3px)';
                            e.currentTarget.style.boxShadow = '0 0 20px rgba(82, 39, 255, 0.6), 0 6px 20px rgba(82, 39, 255, 0.3)';
                            e.currentTarget.style.borderColor = '#5227FF';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = 'none';
                            e.currentTarget.style.borderColor = '#5227FF';
                          }}
                        >
                          {showModel ? 'View 2D' : 'View 3D'}
                        </button>

                        {allowModelLoad && (
                          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.25rem' }}>
                            <button
                              type="button"
                              onClick={onRemoveModel}
                              style={{
                                padding: '0.5rem 1rem',
                                backgroundColor: 'transparent',
                                border: '1px solid #EF4444',
                                borderRadius: '20px',
                                fontSize: '0.9rem',
                                color: '#fca5a5',
                                fontWeight: '300',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease, border-color 0.3s ease'
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-3px)';
                                e.currentTarget.style.boxShadow = '0 0 20px rgba(239, 68, 68, 0.5), 0 6px 20px rgba(239, 68, 68, 0.3)';
                                e.currentTarget.style.borderColor = '#EF4444';
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = 'none';
                                e.currentTarget.style.borderColor = '#EF4444';
                              }}
                            >
                              REMOVE MODEL
                            </button>
                            <span style={{ fontSize: '0.75rem', color: '#9ca3af', fontWeight: 300, letterSpacing: '0.02em', width: '100%', textAlign: 'center' }}>
                              optimize performance
                            </span>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>

          </div>

        </div>
    </section>
  );
};

export default TechnologySection;